import React from 'react'
import SubHeader from '../../layout/components/SubHeader'
import SurveyListPage from "./SurveyListPage";
import { useNavigate } from 'react-router-dom'

function Surveys() {
    const navigate = useNavigate()
      const onCreateSurvey = () => {
        navigate('/surveys/survey-templates');
  }
  return (
    <>
      <SubHeader title="Surveys" description={"Manage and track your patient surveys "}>
        <div className="d-flex justify-content-end">
          <button className="btn btn-primary btn-lg shadow-sm text-white" onClick={onCreateSurvey}>
            <i className="bi bi-plus-circle me-2"></i>Create New Survey
          </button>
        </div>
      </SubHeader>
    <div className='app-container container-xxl'>
          <SurveyListPage />
    </div>
</>
  )
}

export default Surveys